/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import CaseStudiesChildFooter from "./CaseStudiesChildFooter";
import ic_signal_big_circle from "../../assets/images/pictures/icon/ic_signal_cellular_big_circle-64px.svg";
import ic_paper_circle from "../../assets/images/pictures/icon/ic_paper_circle.svg";
import ic_globe_circle from "../../assets/images/pictures/icon/ic_language_circle-40px.svg";
import ic_shield_circle from "../../assets/images/pictures/icon/ic_security_circle-40px.svg";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import { useTranslation } from "react-i18next";
import Footer from "../../components/global/Footer";
import cover from "../../assets/images/logos/case/cover-telco.png";
import bite from "../../assets/images/logos/case/bite_2.png";
import elisa from "../../assets/images/logos/case/elisa.png";
import telia from "../../assets/images/logos/case/telia_2.png";
import tele from "../../assets/images/logos/case/tele2.png";
import NavbarBottom from "../../components/global/NavbarBottom";

const CaseStudiesTelcoContent = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <div className="industries mt-50">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-10 col-sm-offset-1 header">
              <img
                className="header__ic"
                src={ic_signal_big_circle}
                alt=""
                data-no-retina=""
              />
              <h2 className="font-weight-bold">
                {t(
                  "case-studies-telco-page.case-studies-telco-page-content.content-1.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-telco-page.case-studies-telco-page-content.content-1.description"
                )}
              </p>
            </div>
            <div className="col-sm-10 col-sm-offset-1 mb-60">
              <ul className="list-inline text-center">
                <li>
                  <img
                    className="img-bw client-cases"
                    src={telia}
                    alt="Telia"
                  />
                </li>
                <li>
                  <img
                    className="img-bw client-cases"
                    src={elisa}
                    alt="Elisa"
                  />
                </li>
                <li>
                  <img className="img-bw client-cases" src={bite} alt="Bite" />
                </li>
                <li>
                  <img className="img-bw client-cases" src={tele} alt="Tele2" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-color p-0 mt-50">
        <div className="container">
          <div className="row stages">
            <div className="col-xs-12 text-center">
              <h2 className="font-weight-bold">
                {t(
                  "case-studies-telco-page.case-studies-telco-page-content.content-2.big-heading"
                )}
              </h2>
            </div>
            <div className="col-xs-12 text-center mb-10">
              <p>
                {t(
                  "case-studies-telco-page.case-studies-telco-page-content.content-2.big-description"
                )}
              </p>
            </div>
          </div>
          <div className="row mb-80">
            <div className="col-sm-4 stages-legal__box pl-md-0">
              <img src={ic_globe_circle} alt="" data-no-retina="" />
              <div className="stages-legal__box__text">
                <h3>
                  {t(
                    "case-studies-telco-page.case-studies-telco-page-content.content-2.small-heading-1"
                  )}
                </h3>
                <p>
                  {t(
                    "case-studies-telco-page.case-studies-telco-page-content.content-2.small-description-1"
                  )}
                </p>
              </div>
            </div>
            <div className="col-sm-4 stages-legal__box">
              <img src={ic_paper_circle} alt="" data-no-retina="" />
              <div className="stages-legal__box__text">
                <h3>
                  {t(
                    "case-studies-telco-page.case-studies-telco-page-content.content-2.small-heading-2"
                  )}
                </h3>
                <p>
                  {t(
                    "case-studies-telco-page.case-studies-telco-page-content.content-2.small-description-2"
                  )}
                </p>
              </div>
            </div>
            <div className="col-sm-4 stages-legal__box pr-md-0">
              <img src={ic_shield_circle} alt="" data-no-retina="" />
              <div className="stages-legal__box__text">
                <h3>
                  {t(
                    "case-studies-telco-page.case-studies-telco-page-content.content-2.small-heading-3"
                  )}
                </h3>
                <p>
                  {t(
                    "case-studies-telco-page.case-studies-telco-page-content.content-2.small-description-3"
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="industries">
        <div className="container">
          <div className="row about-pro">
            <div className="col-sm-5 pl-md-0">
              <img
                className="img-responsive"
                src={cover}
                alt="Thumbnail pages of E-signing and e-identification in telecommunications: A White Paper"
              />
            </div>
            <div className="col-sm-7">
              <h2 className="font-weight-bold">
                {t(
                  "case-studies-telco-page.case-studies-telco-page-content.content-3.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-telco-page.case-studies-telco-page-content.content-3.description-1"
                )}
              </p>
              <p>
                {t(
                  "case-studies-telco-page.case-studies-telco-page-content.content-3.description-2"
                )}
              </p>
              <a
                className="btn-secondary"
                href="javascript:;"
                data-toggle="modal"
                data-target="#download-book"
              >
                {t(
                  "case-studies-telco-page.case-studies-telco-page-content.content-3.button-access"
                )}
              </a>
            </div>
          </div>
        </div>
        <CaseStudiesChildFooter />
      </div>

      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default CaseStudiesTelcoContent;
